<style scoped="" type="text/css"></style>
<template>
  <el-select style="{'width':width}" :size="size" clearable :disabled="disabled" :multiple-limit="max" v-model="id_bind" :multiple="multiple" collapse-tags filterable :allow-create="false" default-first-option :placeholder="placeholder" @change="change">
    <!-- <el-option v-for="(key,value,index) in options" :key="index" :label="$t(key)" :value="value"></el-option> -->

    <el-option v-for="(item, index) in options" :key="index" :label="isShowValue == true ? item.value + '/' + $t(item.key) : $t(item.key)" :value="item.value" :disabled="disableIdsTmp.indexOf(item.value) != -1"></el-option>
  </el-select>
</template>
<script type="text/javascript">
export default {
  name: 'yi_dictionary_select',
  props: {
    isShowValue: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: function () {
        return this.$t('qingxuanze');
      }
    },
    ids: {},
    width: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'mini'
    },
    max: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disableIds: {
      type: Array,
      default: function () {
        return [];
      }
    },
    type: {
      type: String,
      default: ''
    },
    /*用于过滤显示下拉列表,*/
    showOptionIds: {
      type: Array,
      default: function () {
        return [];
      }
    },
  },

  components: {},
  watch: {
    ids(n, o) {
      if (n == undefined || n == null) {
        this.id_bind = null;
      } else {
        this.id_bind = this.ids;
      }
    }
  },
  computed: {
    disableIdsTmp() {
      let disableIdsTmp = this.utils.copy(this.disableIds);
      for (var i = 0; i < disableIdsTmp.length; i++) {
        disableIdsTmp[i] = disableIdsTmp[i].toString();
      }
      return disableIdsTmp;
    }
  },
  data() {
    return {
      options: [],
      id_bind: this.ids
    };
  },
  created() {
    // this.options = this.store.state.dictJson[this.type]

    for (var key in this.store.state.dictJson[this.type]) {
      if (this.showOptionIds == null || this.showOptionIds.length == 0 || this.showOptionIds.includes(key)) {
        this.options.push({
          value: key + '',
          key: this.store.state.dictJson[this.type][key + '']
        });
      }
    }
  },

  mounted() { },
  methods: {
    change(e) {
      if (this.multiple) {
        this.$emit('update:ids', this.id_bind);
        this.$emit('change', e);
      } else {
        this.$emit('update:ids', this.id_bind);
        this.$emit('change', e);
      }
    }
  }
};
</script>
